import { ref, computed } from 'vue';
import { productMetaFieldTransformer } from '@/components/shop/products/Product';
import { collectionMetaFieldTransformer } from '@/components/shop/collections/Collection';
import * as Sentry from '@sentry/vue';

export const useShopifyCompareData = async (collectionHandle) => {
  const compareCollection = ref([]);
  const currentFilter = ref(null);

  // Fetch data immediately if handle is provided
  if (collectionHandle) {
    const { $shopifyComparisonRequest } = useNuxtApp();
    try {
      compareCollection.value = await $shopifyComparisonRequest({ handle: collectionHandle });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  // Computed properties for rendering
  const compareAttributes = computed(() => {
    if (compareCollection.value?.collection) {
      collectionMetaFieldTransformer(compareCollection.value?.collection);
    }
    return compareCollection.value?.collection?.comparisonHeaders;
  });

  const productList = computed(() => {
    const products = compareCollection.value?.collection?.products?.edges.map((edge) => edge.node) || [];
    return products.map((product) => {
      return productMetaFieldTransformer(product);
    });
  });

  const filteredProductList = computed(() => {
    if (currentFilter.value && productList.value.length) {
      return productList.value.filter((product) => {
        return product.comparison.bestFor?.includes(currentFilter.value);
      });
    }
    return productList.value;
  });

  return {
    compareAttributes,
    productList,
    filteredProductList,
    currentFilter,
  };
};
